import React from "react";
import "./style.css";

const NoInformation = () => {
  return (
    <div className="no_information">
      <p className="idnetifier">N-I</p>
      <small>No Information</small>
    </div>
  );
};

export default NoInformation;
